import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import type { State } from 'src/replicant/State';
import { isDynamicTestInBucket } from 'src/replicant/getters/ab';
import ab from 'src/replicant/ruleset/ab';

export type PurchaseFailureType = 'failed' | 'fatal';

/**
 * Open the purchase failure popup selected by the rollout flag.
 *
 * Enabled players see the redesigned Failed/Fatal popups. When disabled or
 * unassigned, players keep the legacy purchase failure UI. Toggle from the CS
 * tool.
 */
export function openPurchaseFailurePopup(
  state: Pick<State, 'ruleset'>,
  type: PurchaseFailureType,
): Promise<boolean> {
  if (
    !isDynamicTestInBucket(
      state,
      ab.tests.FEATURE_PURCHASE_FAILED_UI,
      'enabled',
    )
  ) {
    return openPopupPromise('popupPurchaseCanceled', { type });
  }

  return type === 'failed'
    ? openPopupPromise('popupPurchaseFailed', {})
    : openPopupPromise('popupPurchaseFatal', {});
}
